import { render, staticRenderFns } from "./petShuttleDetail.vue?vue&type=template&id=728a0e97&scoped=true&"
import script from "./petShuttleDetail.vue?vue&type=script&lang=js&"
export * from "./petShuttleDetail.vue?vue&type=script&lang=js&"
import style0 from "./petShuttleDetail.vue?vue&type=style&index=0&id=728a0e97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728a0e97",
  null
  
)

export default component.exports